export function rgbToRgba(hex, alp) {
  var rgb = []; // 定义rgb数组
  if (/^\#[0-9A-F]{3}$/i.test(hex)) {
    //判断传入是否为#三位十六进制数
    let sixHex = "#";
    hex.replace(/[0-9A-F]/gi, function (kw) {
      sixHex += kw + kw; //把三位16进制数转化为六位
    });
    hex = sixHex; //保存回hex
  }
  if (/^#[0-9A-F]{6}$/i.test(hex)) {
    //判断传入是否为#六位十六进制数
    hex.replace(/[0-9A-F]{2}/gi, function (kw) {
      rgb.push(eval("0x" + kw)); //十六进制转化为十进制并存如数组
    });
    return `rgba(${rgb.join(",")},${alp})`; //输出RGB格式颜色
  } else {
    return "rgb(0,0,0)";
  }
}
